<template>
  <a
    :href="resultUrl"
    :title="result.label"
    @click.stop
  >
    <span class="result-info">
      <DHighlightText
        class="result-label"
        :highlight="searchTerm"
        :text="result.label"
      />
      <span class="more-info">{{ result.user_type }}</span>
    </span>
  </a>
</template>

<script>
import searchResultMixin from '../search-result-mixin';

export default {
  mixins: [
    searchResultMixin,
  ],
};
</script>
